<template>
  <div class="page-content_wrapper projects-container">
    <panel :title="panelConfig.title" :icon="panelConfig.icon">
      <div v-loading="isLoading">
        <template v-if="list.length > 0">
          <bid-item
            v-for="(item, index) in list"
            :key="index"
            :content-length="180"
            :is-preview="$route.params.state === 'preview'"
            :value="item"
          />

          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :current-page="pagination.current"
            :page-size="pagination.size"
            :total="pagination.total"
            @current-change="pageChange"
          />
        </template>

        <empty-layout v-else />
      </div>
    </panel>
  </div>
</template>

<script>
import Panel from '@/components/Panel'
import BidItem from '@/components/BidItem'
import EmptyLayout from '@/components/EmptyLayout'

import { fetchSearchResult, fetchNotice, fetchWin, fetchPreview } from '@/api'

export default {

  components: {
    Panel,
    BidItem,
    EmptyLayout
  },
  data() {
    return {
      list: [],

      pagination: {
        current: 1,
        size: 6,
        total: 0
      },

      isLoading: false
    }
  },

  computed: {
    panelConfig() {
      const config = {
        icon: '',
        title: ''
      }
      const { params, query } = this.$route

      switch (params.state) {
        case 'search':
          config.icon = 'assets/images/icon-bid-notice.png'
          config.title = `以下为“${query.keyword}”的搜索结果：`
          break
        case 'notice':
          config.icon = 'assets/images/icon-bid-notice.png'
          config.title = '招标公告'
          break
        case 'win':
          config.icon = 'assets/images/icon-bid-win.png'
          config.title = '中标公告'
          break
        case 'preview':
          config.icon = 'assets/images/icon-bid-preview.png'
          config.title = '招标预告'
          break
        default:
          config.icon = ''
          config.title = ''
          break
      }

      return config
    }
  },

  watch: {
    '$route': function(newVal) {
      this.list = []
      this.fetchBids()
    }
  },

  created() {
    this.fetchBids()
  },

  methods: {
    async fetchBids(page = 1) {
      this.isLoading = true

      try {
        const params = { pageSize: this.pagination.size, pageNo: page }
        const route = this.$route
        let result

        switch (route.params.state) {
          case 'search':
            result = await fetchSearchResult({ keyword: route.query.keyword || '', ...params })
            break
          case 'notice':
            result = await fetchNotice(params)
            break
          case 'win':
            result = await fetchWin(params)
            break
          case 'preview':
            result = await fetchPreview(params)
            break
          default:
            this.list = []
            this.isLoading = false
            return

            break
        }

        this.list = result.data.records
        this.pagination.total = result.data.total
      } catch (error) {
        this.$message.error(error.message)
      }

      this.isLoading = false
    },

    /*
     * 页数切换
    */
    pageChange(page) {
      document.documentElement.scrollTop = 0

      this.fetchBids(page)
    }
  }
}
</script>

<style lang="scss" scoped>
.projects-container {
  padding-bottom: 48px;
  .el-pagination {
    display: table;
    margin: 50px auto 0;
  }
}
</style>
